import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-publicnavbar',
  templateUrl: './publicnavbar.component.html'
})

export class PublicNavBarComponent {
  title = 'Aetna Devloper Portal';

  apiLib=false;
  getStarted=false;
  support=false;
  welcome=false;
  constructor(private router: Router,private viewportScroller: ViewportScroller) { 

    const pat= this.router.url;
  //  console.log("path :"+pat);
   
      if(pat.includes('/fhirapis')){
        this.apiLib=true;
      }else{

        if(pat.includes('/gettingstarted')){
          this.getStarted=true;
        }else{
          if(pat.includes('/support')){
            this.support=true;
          }
          else{
              this.welcome=true;
          }
        }
           
        
    }


  }

  

  public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }


  public login(){

    localStorage.clear(); 
    sessionStorage.clear();

      localStorage.setItem('devportal_apic_token', 'login');
      this.router.navigate(['dashboard']);
     
    }

}

